const KeyboardExample = () => {
    const naturalNotes = [
        {key: 'A', x: 0},
        {key: 'S', x: 100},
        {key: 'D', x: 200},
        {key: 'F', x: 300},
        {key: 'G', x: 400},
        {key: 'H', x: 500},
        {key: 'J', x: 600},
        {key: 'K', x: 700}
    ]
    const sharpNotes = [
        {key: 'W', x: 65},
        {key: 'E', x: 165},
        {key: 'T', x: 365},
        {key: 'Y', x: 465},
        {key: 'U', x: 565},
    ]
    return (
        <svg width={800} height={300}>
            {naturalNotes.map(n => (
                <g>
                    <rect x={n.x} y={0} width={100} height={300} stroke={"gray"} strokeWidth={2} fill={"white"}/>
                    <text x={n.x + 40} y={260}>{n.key}</text>
                </g>
            ))}
            {sharpNotes.map(n => (
                <g>
                    <rect x={n.x} y={0} width={70} height={200} fill={"black"} />
                    <text x={n.x + 30} y={160} fill={"white"}>{n.key}</text>
                </g>
            ))}
        </svg>
    )
}

export default KeyboardExample